import React, { useState } from 'react';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Heading,
  Icon,
  LinkButton,
  Stack,
  Text,
} from '@eluve/components';
import { TestDefaultsDialog } from '@eluve/frontend-feature-prompt-template-defaults';

import { PromptTemplatesList } from './PromptTemplatesList';

export interface PromptTemplatesListPageProps {}

export const PromptTemplatesListPage: React.FC<
  PromptTemplatesListPageProps
> = () => {
  const [testDialogOpen, setTestDialogOpen] = useState(false);

  return (
    <>
      <Stack gap={2} direction="horizontal">
        <div className="my-2 py-2">
          <Heading>Prompt Templates</Heading>
        </div>
        <Stack
          fullWidth={false}
          className="ml-auto"
          gap={2}
          direction="horizontal"
        >
          <Stack
            className="[&>a]:rounded-r-none [&>a]:border-r-0 [&>button]:rounded-l-none"
            direction="horizontal"
            inline
            align="stretch"
          >
            <LinkButton variant="outline" to="global-defaults">
              <Icon name="Settings2" size="auto" />
              Global Defaults
            </LinkButton>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  aria-label="More prompt template actions"
                >
                  <Icon name="ChevronDown" size="auto" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => setTestDialogOpen(true)}>
                  <Icon name="FlaskConical" />
                  <Text inline size="xs">
                    Test Defaults
                  </Text>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </Stack>
          <LinkButton to="create">
            <Icon name="Plus" size="auto" />
            Create a Prompt Template
          </LinkButton>
        </Stack>
      </Stack>
      <PromptTemplatesList />
      <TestDefaultsDialog
        open={testDialogOpen}
        onOpenChange={setTestDialogOpen}
      />
    </>
  );
};
